import {SoopIcon} from '@soop-ui/soop-ui';
import styles from './EmptyBoard.module.scss';

interface EmptyBoardProps {
  type: 'faq' | 'search' | 'myInquiry';
}

const EmptyBoard = ({type}: EmptyBoardProps) => {
  const isSearch = type === 'search';
  const text = isSearch ? '검색 결과가 없습니다.' : '내용이 없습니다.';

  return (
    <div className={styles.EmptyBox}>
      <SoopIcon
        name='icoEtcNoData'
        width='64px'
        height='64px'
        inheritColors={false}
      />
      <p>{text}</p>
    </div>
  );
};

export default EmptyBoard;
